import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
// The three faces the brand guide names, and nothing else.
//
// Plus Jakarta Sans carries headlines, interface AND body — the guide is
// explicit that it is one family throughout. That is a change from heading-only
// Archivo, and it is affordable for the same reason Archivo was: these are
// latin-subset files whose unicode-range stops the other subsets from ever
// being fetched, served with `font-display: swap`, so a checkout on a slow
// Indian mobile network paints immediately in Inter or the system stack and
// re-renders when the webfont lands. Nothing waits on a font.
//
// Kanit Black Italic is the voice of the logo and is loaded in that one weight
// because it is used in one place. DM Mono is for order numbers and codes,
// where a reader is comparing characters and needs 0 and O to differ.
import '@fontsource-variable/plus-jakarta-sans/wght.css';
import '@fontsource/kanit/900-italic.css';
import '@fontsource/dm-mono/400.css';
import '@fontsource/dm-mono/500.css';

import './index.css';

const container = document.getElementById('root');
if (!container) {
  // A missing #root means index.html and this entry point disagree — a build
  // problem, not a runtime condition, so fail loudly instead of silently.
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  // StrictMode double-invokes effects in development. That is on purpose: it
  // surfaces missing cleanup (event listeners, aborted fetches, focus traps)
  // during development instead of as a leak in production.
  <StrictMode>
    <App />
  </StrictMode>,
);
